var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Card',{class:_vm.styles.root,attrs:{"padding":"orange"}},[_c('Qr',{class:_vm.styles.qr,attrs:{"text":_vm.url}}),_c('ImageSvg',{class:_vm.styles.logo,attrs:{"src":"/images/common/elqr-logo.svg","alt":"elqr logo","height":"28","width":"auto"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }